import React from "react";

import { mobileScreenType } from "@stadium/constants";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { appendBackgroundImage } from "@sendmagic/prismic-nextjs/src/helpers/images";

const RepeatableSection = ({ heading, description, image, ctas, key }) => (
  <div className="bwi-block-holder" key={key}>
    {checkContentPresence(heading) && (
      <div className="font-weight-bold sns-h4 bwi-block-title">{textResolver(heading)}</div>
    )}
    {checkContentPresence(description) && (
      <div className="mt-4 mt-2xl-4 bwi-block-description">{textResolver(description)}</div>
    )}
    {checkContentPresence(ctas) && (
      <div className="mt-3 mt-2xl-3 font-weight-bold bwi-block-link-row program-link">
        {textResolver(ctas)}
      </div>
    )}
    <div className="mt-4 mt-2xl-4 text-center bwi-block-image-row">
      <PrismicImgix
        className="img-responsive img-responsive-height"
        src={image?.url}
        alt={image?.alt}
        desktop="320px"
        mobile="250px"
        tablet="240px"
        largeDisplay="700px"
      />
    </div>
  </div>
);

const BackgroundImageWithText = ({ doc, currentDevice }) => {
  const {
    background_image,
    background_color,
    mobile_background_image,
    heading,
    description,
    highlighted_text,
    highlight_color = "red",
    cta_text,
    cta_link,
    second_cta_text,
    second_cta_link,
    internal_link_id,
    cover = false,
    fill_bg_with_image = false,
  } = doc?.primary || {};
  const { url: imageUrl } = (() => {
    if (typeof window === "undefined") return {};
    if (currentDevice === mobileScreenType) {
      return mobile_background_image;
    }
    return background_image;
  })();

  const sectionStyleBgImg = appendBackgroundImage(imageUrl);
  const sectionStyleBg = { backgroundColor: background_color };
  return (
    <>
      <div className="prismic-slice background-image-text-slice" style={sectionStyleBg}>
        <div
          className={`py-5 py-2xl-5 background-image-text-slice-content-holder ${
            cover ? "background-cover" : ""
          } ${fill_bg_with_image ? "container-width" : ""}`}
          style={sectionStyleBgImg}
        >
          <div className="container container-width py-5 py-2xl-5 background-image-text-slice-container">
            {internal_link_id && (
              <span id={internal_link_id} className="scroll-point position-relative d-block" />
            )}
            {checkContentPresence(heading) && (
              <div className="mb-md-4 mb-2xl-4 mb-3 text-center sns-h1 text-theme-secondary same-size-title background-image-text-slice-title">
                {textResolver(heading)}
              </div>
            )}
            {checkContentPresence(description) && (
              <div className="pb-2 pb-md-0 mx-auto text-center sns-h5 lh-1-point-6 background-image-text-slice-description">
                {textResolver(description)}
              </div>
            )}
            {checkContentPresence(highlighted_text) && (
              <div
                className="mt-md-4 mt-2xl-4 mt-5 pb-2 pb-md-0 mx-auto font-weight-bold text-center sns-h5 fs-09 background-image-text-slice-highlighted"
                style={{ color: highlight_color }}
              >
                {textResolver(highlighted_text)}
              </div>
            )}
            {(checkContentPresence(cta_text) || checkContentPresence(second_cta_text)) && (
              <div className="mt-4 mt-2xl-4 mx-auto text-center background-image-text-slice-btns-row">
                {checkContentPresence(cta_text) && (
                  <PrismicLinkTag
                    url={cta_link?.url}
                    urlText={cta_text}
                    target={cta_link?.target}
                    className="program-link"
                  />
                )}

                {checkContentPresence(second_cta_text) && (
                  <PrismicLinkTag
                    url={second_cta_link?.url}
                    urlText={second_cta_text}
                    target={second_cta_link?.target}
                    className="program-link"
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className="container-fluid container-width bwi-blocks-container bwi-max-container">
          <div className="bwi-blocks-row">
            {doc?.items?.map((props, index) => (
              <RepeatableSection {...props} key={index} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BackgroundImageWithText;
